import React, { Component } from 'react'
import { embedded } from '@services/api'
import { Collapse, Popconfirm, Button, Icon } from 'antd'
const { Panel } = Collapse
import { inject, observer } from 'mobx-react'
import Item from './Item'
import helper from './helper'

@inject((store: any) => {
    const { authStore } = store
    return { authStore }
})
@observer
export default class extends Component {
    state = { embeddedLi: {} }

    updateEmbedded = () => {
        embedded
            .getContent()
            .then(res => {
                let embeddedLi = {}
                res.data.map(em => (embeddedLi[em.name] = { links: {} }))
                res.data.map(em => {
                    let { lng, link, id, updated_at, updated_by, name } = em
                    embeddedLi[name] = lng
                        ? {
                              ...embeddedLi[name],
                              links: { ...embeddedLi[name].links, [lng]: { id, link, updated_at, updated_by } }
                          }
                        : { ...em }
                })
                this.setState({ embeddedLi })
            })
            .catch(err => console.log({ err }))
    }

    componentDidMount() {
        this.updateEmbedded()
    }

    getFreezeIcon = name => (
        <Popconfirm
            title={`האם אתה בטוח שברצונך למחוק לינק זה?`}
            okText="אישור"
            cancelText="ביטול"
            onConfirm={async event => {
                event.stopPropagation()
                event.preventDefault()
                await embedded.dlt({ name })
                this.updateEmbedded()
            }}
        >
            <Button
                onClick={event => {
                    event.stopPropagation()
                    event.preventDefault()
                }}
            >
                <Icon type="delete" />
            </Button>
        </Popconfirm>
    )

    render() {
        return (
            <Collapse style={{ flexDirection: 'column' }} accordion>
                {Object.entries(this.state.embeddedLi).map(([key, value]) => (
                    <Panel
                        header={helper[key] ? helper[key].desc : `טרם ניתן לערוך קישור זה - ${key}`}
                        key={key}
                        disabled={!helper[key]}
                        extra={this.props.authStore.roles.includes('developer') ? this.getFreezeIcon(key) : undefined}
                    >
                        {value['links'] ? (
                            <Collapse accordion key={key}>
                                {Object.entries(value.links).map(([lng, con]) => (
                                    <Panel header={lng} key={lng}>
                                        <Item name={key} con={con} />
                                    </Panel>
                                ))}
                            </Collapse>
                        ) : (
                            <Item con={value} name={key} />
                        )}
                    </Panel>
                ))}
            </Collapse>
        )
    }
}
